import React, { useEffect, useState, useContext, useCallback } from "react";
import axios from "axios";
import Listing from "../components/Listing/listing";
import ListingModal from "../components/Modal/ListingModal";
import { AppContext } from "../AppContext";

export const SavedPosts = () => {
    const [savedPosts, setSavedPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedPost, setSelectedPost] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const { port, userID, token, addAlert } = useContext(AppContext);

    const fetchSavedPosts = useCallback(async () => {
        setIsLoading(true);
        axios.get(`${port}/posts/bookmarks`,
            { 
                data: { userID },
                headers: { Authorization: `Bearer ${token}` } 
            }
        )
        .then((response) => {
            setSavedPosts(response.data.bookmarks);
        })
        .catch((error) => {
            addAlert('Failed to fetch saved posts', 'danger');
        })
        .finally(() => {
            setIsLoading(false);
        });
    }, [addAlert, port, token, userID]);

    const handleRemoveBookmark = async (post_id) => {
        axios.delete(`${port}/posts/bookmarks`, {
            data: { userID, post_id },
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(() => {
            fetchSavedPosts();
        })
        .catch(() => {
            addAlert('Failed to remove bookmark', 'danger');
        });
    };

    const handleListingClick = (post) => {
        setSelectedPost(post);
        setShowModal(true);
    };

    useEffect(() => {
        fetchSavedPosts();
    }, [fetchSavedPosts, userID]);

    return (
        <div className="container mt-4">
            <h1 className="text-center mb-4">Bookmarks</h1>
            {isLoading ? (
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="row">
                    {savedPosts.length > 0 ? (
                        savedPosts.map((post) => (
                            <div className="col-md-4 mb-4" key={post._id}>
                                <div className="listing-wrapper">
                                    <Listing 
                                        post={post}
                                        onBookmark={handleRemoveBookmark}
                                        isBookmarked={true}
                                        onClickListing={handleListingClick}
                                    />
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center">No bookmarked listings available.</p>
                    )}
                </div>
            )}
            {selectedPost && (
                <ListingModal 
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    post={selectedPost}
                />
            )}
        </div>
    );
};